import type { ShopPriceVariant, ShopProduct } from "./types";

/** The variant shown/added by default when the enduser hasn't made an explicit choice yet — the cheapest. */
export const getDefaultVariant = (product: ShopProduct): ShopPriceVariant =>
  product.variants.reduce((cheapest, variant) => (variant.amount < cheapest.amount ? variant : cheapest));

export const findVariant = (product: ShopProduct, stripePriceId: string): ShopPriceVariant | undefined =>
  product.variants.find((variant) => variant.stripePriceId === stripePriceId);
